module.exports = "<div class=\"form-group\">\n    <label>Column</label>\n    <input class=\"form-control\" ng-model=\"element.data.name\" />\n</div>\n\n\n<div class=\"form-group\">\n    <label>Width (Blank = Auto)</label>\n    <input class=\"form-control\" ng-model=\"element.data.width\" />\n</div>\n\n<sgcontenteditor-editor-child-elements children=\"element.children\"></sgcontenteditor-editor-child-elements>"


//////////////////
// WEBPACK FOOTER
// ./sgcontenteditor/elements/properties/column.html
// module id = 407
// module chunks = 0